import { FetchResult, gql } from 'apollo-boost';
import { removeFields } from '../../helpers/common-helpers';
import { IEmotionEpisode } from '../../models/emotion-episode';
import { MultiError } from '../../types/multi-error';
import { graphqlClient } from '../graphql-client';

const QUERY = gql`
    {
        emotion_episodes_get_saved {
            uid,
            description,
            start,
            end,
            mediaUrls: media_urls,
            absoluteStart: absolute_start,
            available,
            savedAt: saved_at,
            savedOnService: saved_on_service,
            contentTags: content_tags {
                uid,
                name,
                tagType: tag_type
            },
            comment {
                uid,
                html,
                entity_uid,
                entity_type,
            },
            participants {
              uid,

              character {
                uid,
                name,
                importance,
                gender,
                shortName: short_name,
                fileName: file_name,
              }

              emotions {
                uid,
                description,
                intensity,
              }
            },
            saved
            scene {
                uid,
                description,

                narrative {
                    uid,
                    title,
                    fileName: file_name
                }

                episode {
                    uid,
                    name,
                    season,
                    numberInSeason: number_in_season,
                }
            }
        }
    }
`;

export async function getSavedEmotionEpisodes(): Promise<IEmotionEpisode[]> {
    const result: FetchResult<{ emotion_episodes_get_saved: IEmotionEpisode[] }> = await graphqlClient.query({
        query: QUERY,
        variables: {},
        errorPolicy: 'all',
    });

    if (!result.data || result.errors && result.errors.length) {
        throw new MultiError(result.errors || ['Unknown error']);
    }

    return removeFields(result.data.emotion_episodes_get_saved, ['__typename']);
}
